<script setup lang="ts">
import { defineProps, defineModel } from "vue";

type Props = {
  title?: string;
  isRequired?: boolean;
  placeholder?: string;
  isError?: boolean;
  errorMessage?: string;
  modelValue: string;
};

defineProps<Props>();

const textModel = defineModel<string>({ required: true });
</script>

<template>
  <div class="w-full flex flex-col items-start">
    <p
      class="text-base leading-[26px] tracking-[0.01rem] font-medium text-[#898790] pb-[6px]"
    >
      {{ title }}
    </p>
    <input
      class="p-3 mb-1 rounded-primary-radius border resize-none w-full outline-none bg-[#F9F8F6] text-black text-base leading-[26px] tracking-[0.01rem] font-medium placeholder:text-[#898790]"
      :class="`${isError ? 'border-[#ED857F]' : ''} 
          ${!isError && !textModel ? 'border-[#E3E1EA]' : ''} 
          ${textModel && textModel.length > 0 ? 'border-[#393840]' : ''} `"
      type="text"
      :placeholder="placeholder"
      v-model="textModel"
    />
    <div class="flex gap-1 items-center mt-1" v-if="isError">
      <img src="@/assets/warning-red.svg" alt="Warning" />
      <span class="text-[#ed857f] text-sm">{{ errorMessage }}</span>
    </div>
  </div>
</template>
